export const doi_annual_report = [
  {
    id: 1,
    name: 'wc-provincial-treasury-2024_25-annual-report',
    summary: 'shortsummary/wc-provincial-treasury-2024_25-annual-report.html',
    link: 'wc-provincial-treasury-2024_25-annual-report.pdf',
    audio_en: 'audio/en/wc-provincial-treasury-2024_25-annual-report_en.mp3',
    audio_af: 'audio/af/wc-provincial-treasury-2024_25-annual-report_af.mp3',
    audio_xh: 'audio/xh/wc-provincial-treasury-2024_25-annual-report_xh.mp3'
  }
];